export interface NamedEntityInput {
  id?: number | null;
  name?: string | null;
}

export interface NamedEntity {
  id: number;
  name: string;
}

export const mapNamedEntity = (entity: NamedEntityInput | null | undefined): NamedEntity => ({
  id: entity?.id ?? 0,
  name: entity?.name ?? 'N/A'
});
